import React from "react";
import { WORKOUT } from "@/constants/testIds";
import { Sparkles } from "lucide-react";

/**
 * AI progression suggestions card. Fetched on-demand via the parent.
 */
export default function WorkoutProgression({ progression, loading, onGenerate }) {
  return (
    <div className="obs-card" data-testid="workout-progression">
      <div className="flex items-center justify-between mb-4">
        <div>
          <div className="overline">AI Progression Engine</div>
          <h3 className="font-heading text-3xl uppercase mt-1">What to push next.</h3>
        </div>
        <button
          data-testid={WORKOUT.progressionBtn}
          onClick={onGenerate}
          disabled={loading}
          className="blaze-btn px-5 py-2.5 text-xs inline-flex items-center gap-2 disabled:opacity-50"
        >
          <Sparkles className="h-4 w-4" /> {loading ? "Analyzing..." : "Generate"}
        </button>
      </div>
      {progression?.suggestions?.length ? (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {progression.suggestions.map((s, idx) => (
            <div key={idx} className="border border-obsidian-600 rounded-sm p-4 bg-obsidian-900/40">
              <div className="overline text-blaze mb-1">{s.action?.replaceAll("_", " ")}</div>
              <div className="font-heading text-xl uppercase">{s.exercise}</div>
              <div className="mt-2 text-sm text-zinc-300">{s.recommendation}</div>
              <div className="mt-3 grid grid-cols-3 gap-2 text-xs">
                <div>
                  <div className="overline">Weight</div>
                  <div className="font-data text-sm">{s.target_weight_kg} kg</div>
                </div>
                <div>
                  <div className="overline">Reps</div>
                  <div className="font-data text-sm">{s.target_reps}</div>
                </div>
                <div>
                  <div className="overline">Sets</div>
                  <div className="font-data text-sm">{s.target_sets}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-zinc-500 text-sm">
          {progression?.message || "Click generate after logging at least one workout."}
        </p>
      )}
    </div>
  );
}
